export const languageTemplate: string[][] = [
  ['Deutsch', 'DE', 'Übersetzen'],
  ['Nederlands', 'NL', 'Vertaling'],
  ['Polski', 'PL', 'Tłumaczenie'],
  ['Türkçe', 'TR', 'Çeviri'],
  ['Čeština', 'CS', 'Překlad']
];
